<mat-card (click)="select(serviceProvider)">
  <mat-card-content>
    <img src="{{serviceProvider.logo?.uri}}" alt="{{serviceProvider.name}}" class="logo">
  </mat-card-content>
</mat-card>
